<ng-container [ngSwitch]="filter?.config?.filterType">
    <ng-container *ngSwitchCase="'range'">
        <gen-range-input [filter]="filter" class="filter-input-flex-one"></gen-range-input>
    </ng-container>
    <ng-container *ngSwitchCase="'dropdown'">
        <gen-dropdown-input [filter]="filter" class="filter-input-flex-one"></gen-dropdown-input>
    </ng-container>
    <ng-container *ngSwitchCase="'autocomplete'">
        <s-autoComplete class="enterVal" placeholder="{{'Enter value'}}" [appendTo]="'body'" inputId="id" field="id"
                        [(ngModel)]="filter.selectedValue.value" [multiple]="true" [minLength]="2">
        </s-autoComplete>
    </ng-container>
    <ng-container *ngSwitchCase="'checkboxlist-icon'">
        <gen-checkboxlistIcon-input [filter]="filter" class="filter-input-flex-one"></gen-checkboxlistIcon-input>
    </ng-container>
</ng-container>
